import type { FC, ReactNode } from 'react';
import { cn } from '../../lib/lib';

export interface LeaderboardProps {
  rows: ReactNode;
  title: string;
  tooltip: ReactNode;
  icon: ReactNode;
  header: {
    rank: ReactNode;
    main: { short: ReactNode; long: ReactNode };
    sub: ReactNode;
    point: ReactNode;
  };
}

export const LeaderboardHeaderMobile = ({
  title,
  subtitle,
  rightContent,
  icon,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  rightContent?: ReactNode;
  icon: ReactNode;
}) => {
  return (
    <div className="bg-back600 flex items-center justify-between gap-2.5 p-5">
      <div className="flex items-center gap-2.5">
        {icon && (
          <div className="bg-back200 flex size-10 items-center justify-center rounded-full">
            {icon}
          </div>
        )}
        <div className="text-text300 flex flex-col text-sm font-medium">
          <div>{title}</div>
          {subtitle && <div className="text-text700 text-xs">{subtitle}</div>}
        </div>
      </div>
      {rightContent && <div />}
    </div>
  );
};

export const LeaderboardMobile: FC<{
  rows: ReactNode;
  header: ReactNode;
  className?: string;
}> = ({ rows, header, className }) => {
  return (
    <div
      className={cn(
        'bg-back300 block overflow-hidden rounded-xl md:hidden',
        className
      )}
    >
      {/* <LeaderboardHeaderMobile title={title} rightContent={rightHeaderContent} icon={icon} /> */}
      {header}
      <div className="flex flex-col p-5">{rows}</div>
    </div>
  );
};

export const LeaderboardHeaderDesktop = ({
  title,
  rightContent,
  icon,
  subtitle,
}: {
  title: ReactNode;
  rightContent?: ReactNode;
  icon: ReactNode;
  subtitle?: ReactNode;
}) => {
  return (
    <div className="bg-back600 flex items-center gap-2.5 p-5">
      {icon && (
        <div className="bg-back200 flex size-10 shrink-0 grow-0 items-center justify-center rounded-full md:size-[60px]">
          {icon}
        </div>
      )}
      <div className="text-text300 flex flex-col text-sm font-medium">
        <div>{title}</div>
        {subtitle && <div className="text-text700 text-xs">{subtitle}</div>}
      </div>
      {rightContent && <div />}
    </div>
  );
};
export const LeaderboardDesktop: FC<{
  rows: ReactNode;
  header: ReactNode;
  className?: string;
}> = ({ rows, header, className }) => {
  return (
    <div
      className={cn(
        'bg-back300 hidden overflow-hidden rounded-xl md:block',
        className
      )}
    >
      {header}
      <div className="back-back300 px-5 py-2.5">{rows}</div>
    </div>
  );
};
